import { defineStore } from "pinia";
import api from "~/config/extensionsApi";
import CryptoJS from "crypto-js";
import { useCustomerStore } from "~/modules/customer/stores/customer";
import { postApiAxios, getDaysUntilExpiry, getCurrentTime, getApiAxios } from "~/helpers/index";

export const useVoucherStore = defineStore("voucher", {
  state: ()=> ({
    voucherData: null,
    loading: false,
    error: null,
    codeVoucher: null,
    ruleId: null,
  }),

  getters: {
    getVoucherData(state) {
      return state.voucherData;
    },
    isLoading(state) {
      return state.loading;
    },
    getError(state) {
      return state.error;
    },

    getRuleId(state) {
      return state.ruleId;
    }
  },

  actions: {
    async fetchVoucherDataStore() {
      this.loading = true;
      this.error = null;
      const customerStore = useCustomerStore();
      const user = customerStore.user;
      if (!user) {
        this.error = new Error("Customer is not logged in.");
        return;
      }
      const { phone_number, customer_id } = user;

      if (!phone_number || !customer_id) {
        this.error = new Error("Customer ID or phone number is missing.");
        return;
      }

      let key = CryptoJS.enc.Hex.parse(api.otp.crypto_key);
      let iv = CryptoJS.enc.Hex.parse(api.otp.crypto_iv);
      let encrypted = CryptoJS.AES.encrypt(phone_number, key, { iv: iv });
      encrypted = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

      try {
        const url = api.customer.customer_getlistvoucher;
        const response = await postApiAxios(url, {
          limit: 50,
          offset: 0,
          customerId: customer_id,
          phoneNumber: encrypted,
        });
        const countExiringVouchers = filterExpiringVouchers(response?.result);
        this.voucherData = { ...response, result: { ...response.result, countExiringVouchers } };
      } catch (err) {
        this.error = new Error("Unexpected authorization error. Check your Network connection.");
      } finally {
        this.loading = false;
      }
    },
    resetVoucherDataStore() {
      this.voucherData = null;
    },

    async getCodeVoucher(ruleId: string) {
      try {
        this.loading = true;
        const response = await getApiAxios(api.erpVoucher.get_voucher + `?rule_id=${ruleId}`);
        const codeVoucher = response.result?.[0]?.code || null;
        return codeVoucher;
      } catch (error) {
        console.error("Error fetching codeVoucher:", error);
      } finally {
        this.loading = false;
      }
    },

    setRuleId(ruleId: string) {
      this.ruleId = ruleId;
    }
  },
});

function filterExpiringVouchers(voucherData: any) {
  if (!voucherData || !voucherData.vouchers) return [];
  return voucherData.vouchers.filter(
    (item: any) =>
      (getDaysUntilExpiry(item.to_date || item.expiry_date) > 0 && getDaysUntilExpiry(item.to_date || item.expiry_date) < 4) ||
      (getCurrentTime(item.to_date || item.expiry_date) > 0 && getDaysUntilExpiry(item.to_date || item.expiry_date) == 0)
  ).length;
}
